import { Alert } from 'common';
import { SubmissionState } from './ReviewAndSubmit';

export type LockedFormStatus = 'success' | 'skipped';

/** Submit and Retry leave out sent and skipped documents, so their forms are disabled. */
export function getLockedFormStatus(state: SubmissionState | undefined): LockedFormStatus | null {
    if (state?.status === 'success' || state?.status === 'skipped') {
        return state.status;
    }
    return null;
}

export function LockedFormNotice({ status }: { status: LockedFormStatus | null }) {
    if (status === 'success') {
        return (
            <Alert severity="success" testId="post-signup-form-submitted">
                Document successfully submitted.
            </Alert>
        );
    }
    if (status === 'skipped') {
        return (
            <Alert severity="info" testId="post-signup-form-skipped">
                Document skipped. It won't be sent.
            </Alert>
        );
    }
    return null;
}
